import { useEffect, useRef, useState } from "react";
import Configuraciones from "../../page/configuraciones/Configuraciones"
import apiPrivateAntesala from "../../../config/ConfigPrivate";

const ConfiguracionesController = () => {
    const [banners, setBanners] = useState(null);
    const [categorias, setCategorias] = useState(null);
    const [categoriasNotas, setCategoriasNotas] = useState(null);
    const [provincias, setProvincias] = useState(null);
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState({
        per_page: 10,
        ["filter[stated]"]: "ACTIVO",
        sort: "-id",
    });
    const controllerRef = useRef(null);

    const fetch = async (setData, params, url, signal, loading) => {
        try {
            const response = await apiPrivateAntesala.get(url, {
                params,
                signal,
            });
            if (response.status == 201 || response.status == 200) {
                setData(response.data);
                if (loading) {
                    loading(false);
                }
            }
        } catch (error) {
            if (error.name === "AbortError") {
                console.log("Request aborted");
            } else {
                console.error("Error fetching data:", error);
            }
        }
    };

    useEffect(() => {
        if (!banners) {
            setLoading(true);
            let params = {
                ...filter,
            };
            fetch(setBanners, params, "/banners", null, setLoading);
        }
    }, []);

    useEffect(() => {
        if (!categorias) {
            setLoading(true);
            let params = {};
            fetch(setCategorias, params, "/categorias", null, setLoading);
        }
    }, []);

    useEffect(() => {
        if (!categoriasNotas) {
            setLoading(true);
            let params = {};
            fetch(setCategoriasNotas, params, "/categorias-nota", null, setLoading);
        }
    }, []);

    useEffect(() => {
        if (!provincias) {
            setLoading(true);
            let params = {
                list: true
            };
            fetch(setProvincias, params, "/provincias", null, setLoading);
        }
    }, []);

    const onClick = (e, value) => {

    }

     const onChange = (e, value) => {
        
    }

    console.log("banners", banners);
    console.log("categorias", categorias);
    console.log("categoriasNotas", categoriasNotas);

    if(!categoriasNotas || !categorias || !banners){
        return ""
    }

    return <Configuraciones
        provincias={provincias}
        banners={banners}
        categorias={categorias}
        categoriasNotas={categoriasNotas}
        loading={loading}
        onClick={onClick}
        onChange={onChange}
        setFilter={setFilter}
        filter={filter}

        setBanners={setBanners}
        setCategorias={setCategorias}
        setCategoriasNotas={setCategoriasNotas}
    />
}

export default ConfiguracionesController